// Funcion para formatear un numero de telefono.
export function formatTelefono(telefono) {
  if (!telefono) return "";

  const normalized = String(telefono).replace(/\s+/g, "").trim();

  if (normalized.startsWith("+48") && normalized.length === 12) {
    const localNumber = normalized.slice(3);
    return `+48 ${localNumber.slice(0, 2)} ${localNumber.slice(
      2,
      5
    )} ${localNumber.slice(5, 7)} ${localNumber.slice(7, 9)}`;
  }

  let formatted = "";
  let count = 0;
  for (let i = 0; i < normalized.length; i++) {
    if (count === 4 || count === 7) {
      formatted += " ";
    }
    formatted += normalized[i];
    count++;
  }

  return formatted;
}
